import { Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { ConnectPositions, ConnectRewards, GameObject, RankingByLogin, TooltipType, ComparisonType } from '../game.models';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { cloneDeep } from 'lodash';
import { GamesService } from 'src/app/gamification/command-center/services/games.service';
import { TooltipDirective } from "ngx-bootstrap/tooltip";
import { GenericMetricFormatterPipe } from "src/app/reusables/pipes/generic-metric-formatter.pipe";
import { CxoneGamesConnect3SlotComponent } from "./cxone-games-connect-3-slot/cxone-games-connect-3-slot.component";

@Component({
	selector: 'cxone-games-connect-3',
	templateUrl: './cxone-games-connect-3.component.html',
	styleUrl: './cxone-games-connect-3.component.scss'
})
export class CxoneGamesConnect3Component implements OnInit {
	@Input() game: GameObject;
	@Input() gameType: number;
	@Input() gameStatus: string;
	@Input() ranking: RankingByLogin;

	@ViewChild('qualifierText') qualifierText: ElementRef<HTMLElement>;
	@ViewChild('metricText', { static: false }) metricText: ElementRef;
	@ViewChild('tooltip', { static: false }) tooltip!: TooltipDirective;
	@ViewChild('tooltipQualifier', { static: false }) tooltipQualifier!: TooltipDirective;
	@ViewChildren('connect3Slot') connect3Slot!: QueryList<CxoneGamesConnect3SlotComponent>;

	metricCompleted = [];
	connect3Positions: ConnectPositions[] = [];
	connect3Rewards: ConnectRewards;
	gs = null;
	coins = null;
	badge = null;
	tooltipValidation = false;
	TooltipType = TooltipType;
	ComparisonType = ComparisonType;

	constructor(
		public cvLocalizationService: CVLocalizationService,
		private gamesService: GamesService,
		public metricFormatter: GenericMetricFormatterPipe,
	) {
		this.gs = this.gamesService;
	}

	ngOnInit(): void {
		this.getMetricPositions();
		this.getConnect3Rewards();
	}
	
    getFormattedData(value, conversionType): string {
        return this.metricFormatter.transform(value, conversionType);
    }

	getConnect3Class(metricPosition: ConnectPositions, gameType: number) {
		let metricData = null;
		if (this.ranking != null && this.ranking?.gameRewards?.MyRankingObj != null) {
			metricData = this.ranking?.gameRewards?.MyRankingObj?.MetricGroupInfos?.filter((a: any) => {
				return a.MetricID === metricPosition.metric.metricID;
			})[0];
			if (metricPosition.metric.metricID == -1) { this.metricCompleted[metricPosition.position] = true; } // Free Space = true
		}
		let classes: string = '';
		if (metricPosition.metric.metricID == -1) gameType == 6 ? classes = 'freeSpace' : classes = 'freeSpaceBlackout';
		if (metricPosition.metric == null) classes = 'empty';
		if (metricPosition.metric != null && metricPosition.metric.metricID > -1 && metricData == null) gameType == 6 ? classes = 'empty' : classes = 'empty';
		if (metricPosition.metric != null && metricPosition.metric.metricID > -1 && metricData != null) {
			if (metricPosition.targetObj.Direction == 0) {
                if (metricData?.MyMetricValue <= metricPosition.targetObj.Target && this.gs.isQualified(this.ranking?.gameRewards?.MyRankingObj?.MetricGroupInfos[this.ranking?.gameRewards?.MyRankingObj?.MetricGroupInfos?.length - 1]?.MyMetricValue, this.game, this.ranking)) {
					gameType == 6 ? classes = 'completed' : classes = 'completedBlackout';
				} else {
					gameType == 6 ? classes = 'empty' : classes = 'empty';
				}
			} else {
                if (metricData?.MyMetricValue >= metricPosition.targetObj.Target && this.gs.isQualified(this.ranking?.gameRewards?.MyRankingObj?.MetricGroupInfos[this.ranking?.gameRewards?.MyRankingObj?.MetricGroupInfos?.length - 1]?.MyMetricValue, this.game, this.ranking)) {
					gameType == 6 ? classes = 'completed' : classes = 'completedBlackout';
				} else {
					gameType == 6 ? classes = 'empty' : classes = 'empty';
				}
			}
			this.metricCompleted[metricPosition.position] = (classes === 'completed' || classes === 'completedBlackout' || classes === 'freeSpaceBlackout' || classes === 'freeSpace');
		}
		return classes;
	}

	getMetricPositions() {
		this.connect3Positions = [...this.game?.Connect3Positions?.sort((a, b) => a.position - b.position)];
		if (this.connect3Positions.length === 8) {
			const freePositionCopy = cloneDeep(this.connect3Positions[3]);
			freePositionCopy.metric.metricID = -1;
			this.connect3Positions.splice(4, 0, freePositionCopy);
		}
	}

	getConnect3Rewards() {
		const rewards = this.game?.Connect3Rewards;

		if (!rewards) return null;

		this.connect3Rewards = rewards;

		const rewardType = this.gameType === 6 ? 'ThreeInRow' :
			this.gameType === 7 ? 'Blackout' :
				null;

		if (rewardType) {
			this.coins = rewards[rewardType]?.coins;
			this.badge = rewards[rewardType]?.badge;
		}
	}

	checkTextTruncation(tooltip: string, type: TooltipType): string {
		this.tooltipValidation = true;
		switch (type) {
			case TooltipType.Q1:
				if (this.metricText) {
					return this.metricText.nativeElement.scrollWidth != this.metricText.nativeElement.clientWidth ? tooltip : "";
				}
				break;
			case TooltipType.Q2:
				if (this.qualifierText) {
					return this.qualifierText.nativeElement.scrollWidth != this.qualifierText.nativeElement.clientWidth ? tooltip : "";
				}
				break;
			default: this.tooltipValidation = false;
		}
		return "";
	}
	
	hideTooltips() {
		if (this.connect3Slot) {
			this.connect3Slot.forEach(slot => slot.hideTooltip());
		}
	}
}
	